import { render, staticRenderFns } from "./PainterImgOrder.vue?vue&type=template&id=ef61cbc4&scoped=true"
import script from "./PainterImgOrder.vue?vue&type=script&lang=js"
export * from "./PainterImgOrder.vue?vue&type=script&lang=js"
import style0 from "./PainterImgOrder.vue?vue&type=style&index=0&id=ef61cbc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef61cbc4",
  null
  
)

export default component.exports